import { ApiContext } from '../../types';
import {
  GetBookingsSettingsResponse,
  RequestedFields,
} from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { getBookingsSettings as getBookingsSettingsHttp } from '@wix/ambassador-bookings-v2-bookings-settings/http';

export const getBookingsSettings = async ({
  flowAPI,
}: ApiContext): Promise<GetBookingsSettingsResponse> => {
  const { httpClient } = flowAPI;
  return (
    await httpClient.request(
      getBookingsSettingsHttp({
        fields: [RequestedFields.SITE_PROPERTIES, RequestedFields.FEATURES],
      }),
    )
  ).data;
};
